import { Contact } from "../slice/authSliceLogin/authSliceLogin";
import {
  Chronology,
  IAgent,
  IUserContract,
} from "../slice/listAgentSlice/listAgentSlice";
import { api } from "./apiCore";

interface IAgentArchive {
  agent_id: number;
  is_enabled: boolean;
}

export interface AgentBankChronologyRequest {
  bank_id: number;
  start_date: string;
  excess_agent: number;
  commission_agent_rate: number;
}

export interface IApiAgentRequest {
  user: {
    id?: number;
    surname?: string;
    name?: string;
    patronymic?: string;
    email?: string;
    inn?: string | number;
    phone_number?: string;
  };
  organization: {
    inn?: string | number;
    ogrn?: string;
    name?: string;
    phone_number?: string;
    email?: string;
    snils?: string;
  } | null;
}

export const listAgentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // архивировать агента
    archiveAgent: builder.mutation<IAgentArchive, IAgentArchive>({
      query: (value) => ({
        url: `/auth/user/${value.agent_id}/enable`,
        method: "PATCH",
        body: {
          is_enabled: value.is_enabled,
        },
      }),
    }),
    editAgent: builder.mutation<IAgent, IApiAgentRequest>({
      query: (value) => ({
        url: `/auth/user/${value.user.id}`,
        method: "PUT",
        body: {
          user: {
            surname: value.user.surname,
            name: value.user.name,
            patronymic: value.user.patronymic,
            email: value.user.email,
            inn: value.user.inn,
            phone_number: value.user.phone_number,
          },
          organization: {
            inn: value.organization?.inn,
            ogrn: value.organization?.ogrn,
            name: value.organization?.name,
            phone_number: value.organization?.phone_number,
            email: value.organization?.email,
            snils: value.organization?.snils,
          },
        },
      }),
      transformResponse: (response: { data: IAgent }) => response.data,
    }),
    // добавить контактное лицо сам агент
    addContact: builder.mutation<
      { data: Contact; message: string },
      Omit<Contact, "id" | "user_id">
    >({
      query: (value) => ({
        url: `/auth/user/contacts`,
        method: "POST",
        body: {
          surname: value.surname,
          name: value.name,
          patronymic: value.patronymic,
          email: value.email,
          phone_number: value.phone_number,
        },
      }),
    }),
    // удалить контактное лицо
    deleteContact: builder.mutation<
      { data: Contact; message: string },
      Pick<Contact, "id">
    >({
      query: (value) => ({
        url: `/auth/user/contacts/${value.id}`,
        method: "DELETE",
      }),
    }),
    // изменить контактное лицо
    updateContact: builder.mutation<
      { data: Contact; message: string },
      Omit<Contact, "user_id">
    >({
      query: (value) => ({
        url: `/auth/user/contacts/${value.id}`,
        method: "PUT",
        body: {
          surname: value.surname,
          name: value.name,
          patronymic: value.patronymic,
          email: value.email,
          phone_number: value.phone_number,
        },
      }),
    }),
    // добавить контактное лицо через админку
    addContactAdmin: builder.mutation<
      { data: Contact; message: string },
      Omit<Contact, "id">
    >({
      query: (value) => ({
        url: `/auth/admin/contacts/${value.user_id}`,
        method: "POST",
        body: {
          surname: value.surname,
          name: value.name,
          patronymic: value.patronymic,
          email: value.email,
          phone_number: value.phone_number,
        },
      }),
    }),
    // удалить контактное лицо через админку
    deleteContactAdmin: builder.mutation<
      { data: Contact; message: string },
      Pick<Contact, "id">
    >({
      query: (value) => ({
        url: `/auth/admin/contacts/${value.id}`,
        method: "DELETE",
      }),
    }),
    // обновить контактное лицо через админку
    updateContactAdmin: builder.mutation<
      { data: Contact; message: string },
      Omit<Contact, "user_id">
    >({
      query: (value) => ({
        url: `/auth/admin/contacts/${value.id}`,
        method: "PUT",
        body: {
          surname: value.surname,
          name: value.name,
          patronymic: value.patronymic,
          email: value.email,
          phone_number: value.phone_number,
        },
      }),
    }),
    // изменить контактное лицо через админку
    changeUserContact: builder.mutation<
      { data: IUserContract; message: string },
      Omit<IUserContract, "item_id" | "type">
    >({
      query: (value) => ({
        url: `/auth/admin/contract/${value.id}`,
        method: "PUT",
        body: {
          start_contract: value.start_contract,
          is_sign: value.is_sign,
          number_contract: value.number_contract,
        },
      }),
    }),
    // Добавить банк в хронологию агента
    addAgentBankChronology: builder.mutation<
      Chronology,
      { chronology_data: AgentBankChronologyRequest; agent_id: number }
    >({
      query: (value) => ({
        url: `/auth/admin/create-agent-chronology/${value.agent_id}`,
        method: "POST",
        body: value.chronology_data,
      }),
      transformErrorResponse: (response) => {
        return response.data.message;
      },
    }),
  }),
});

export const {
  useArchiveAgentMutation,
  useEditAgentMutation,
  useAddContactMutation,
  useDeleteContactMutation,
  useUpdateContactMutation,
  useAddContactAdminMutation,
  useDeleteContactAdminMutation,
  useUpdateContactAdminMutation,
  useChangeUserContactMutation,
  useAddAgentBankChronologyMutation,
} = listAgentApi;
